import { Route } from "react-router-dom";

import { MASTER_ROUTES } from "src/pages/master/constants";

import { BlankPage } from "./BlankPage";

/** Miscellaneous top-level routes owned by the master module. */
export const masterRoutes = <Route path={MASTER_ROUTES.blankPage} element={<BlankPage />} />;
